<template>
  <el-form
    label-position="left"
    :model="contactForm"
    status-icon
    ref="contactForm"
    @submit.native.prevent="next('contactForm', contactForm)"
  >
    <el-row :gutter="15" justify="center" type="flex" v-loading="saving">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="Prefijo | Teléfono">
              <div class="flex flex-row w-full">
                <el-select
                  size="small"
                  v-model="contactForm.phoneCode"
                  slot="prepend"
                  placeholder="Select"
                  class="w-28"
                  filterable
                  default-first-option
                >
                  <el-option
                    v-for="(c, k) in filteredCountries"
                    :key="k"
                    :label="c.phoneCode != null ? c.phoneCode : 'Otro'"
                    :value="c.id"
                  >
                    <span class="float-left mr-4">{{
                      c.phoneCode != null ? c.phoneCode : "Otro"
                    }}</span>
                    <span class="float-right text-xs text-gray-600">{{
                      c.name
                    }}</span>
                  </el-option>
                </el-select>
                <el-input
                  size="small"
                  v-model="contactForm.phone"
                  autocomplete="off"
                  :placeholder="findMask(contactForm.phoneCode)"
                  v-mask="findMask(contactForm.phoneCode)"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Prefijo | Celular">
              <div class="flex flex-row w-full">
                <el-select
                  size="small"
                  v-model="contactForm.cellphoneCode"
                  slot="prepend"
                  placeholder="Select"
                  class="w-28"
                  filterable
                  default-first-option
                >
                  <el-option
                    v-for="(c, k) in filteredCountries"
                    :key="k"
                    :label="c.phoneCode != null ? c.phoneCode : 'Otro'"
                    :value="c.id"
                  >
                    <span class="float-left mr-4">{{
                      c.phoneCode != null ? c.phoneCode : "Otro"
                    }}</span>
                    <span class="float-right text-xs text-gray-600">{{
                      c.name
                    }}</span>
                  </el-option>
                </el-select>
                <el-input
                  size="small"
                  v-model="contactForm.cellphone"
                  autocomplete="off"
                  :placeholder="findMask(contactForm.cellphoneCode)"
                  v-mask="findMask(contactForm.cellphoneCode)"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Correo">
              <el-input
                size="small"
                v-model="contactForm.email"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item label="Nombre contacto de emergencia">
              <el-input
                size="small"
                v-model="contactForm.emergencyPerson"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Prefijo | Número contacto de emergencia">
              <div class="flex flex-row w-full">
                <el-select
                  size="small"
                  v-model="contactForm.emergencyPhoneCode"
                  slot="prepend"
                  placeholder="Select"
                  class="w-28"
                  filterable
                  default-first-option
                >
                  <el-option
                    v-for="(c, k) in filteredCountries"
                    :key="k"
                    :label="c.phoneCode != null ? c.phoneCode : 'Otro'"
                    :value="c.id"
                  >
                    <span class="float-left mr-4">{{
                      c.phoneCode != null ? c.phoneCode : "Otro"
                    }}</span>
                    <span class="float-right text-xs text-gray-600">{{
                      c.name
                    }}</span>
                  </el-option>
                </el-select>
                <el-input
                  size="small"
                  v-model="contactForm.emergencyPhone"
                  autocomplete="off"
                  :placeholder="findMask(contactForm.emergencyPhoneCode)"
                  v-mask="findMask(contactForm.emergencyPhoneCode)"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24" class="flex justify-end">
            <el-button size="small" @click="$emit('cancel')"
              >Cancelar</el-button
            >
            <el-button size="small" type="primary" native-type="submit"
              >Guardar</el-button
            >
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import dfn from "date-fns";

export default {
  name: "DialogContact",
  props: ["values", "countries"],
  data() {
    return {
      contactForm: {
        phone: "",
        phoneCode: "",
        cellphone: "",
        cellphoneCode: "",
        email: "",
        emergencyPhone: "",
        emergencyPhoneCode: "",
        emergencyPerson: "",
      },
      saving: false,
    };
  },
  methods: {
    next(formName, datos) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.saving = true;

        this.$confirm(
          "¿Estás seguro que deseas actualizar estos datos?",
          "Confirmación",
          {
            confirmButtonText: "Si, actualizar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        )
          .then(() => {
            axios
              .post("/", {
                query: `mutation { 
                  employeeUpdate(
                    where: { id: "${datos.id}" },
                    data: {
                      phone: "${datos.phone}",
                      cellphone: "${datos.cellphone}",
                      emergencyPhone: "${datos.emergencyPhone}",
                      phoneCode: ${datos.phoneCode},
                      cellphoneCode: ${datos.cellphoneCode},
                      emergencyPhoneCode: ${datos.emergencyPhoneCode},
                      email: "${datos.email}",
                      emergencyPerson: "${datos.emergencyPerson}",
                    }
                  ) { id } 
                }`,
              })
              .then((res) => {
                const { data, error } = res.data;
                this.$notify({
                  title: "Éxito",
                  message: "Se ha actualizado la información correctamente.",
                  type: "success",
                });
                this.$emit("save", true);
              })
              .catch(console.log)
              .then((alw) => {
                this.saving = false;
              });
          })
          .catch((this.saving = false));
      });
    },
    findMask(country) {
      return country == null || country == ""
        ? "####################"
        : this.countries.find((c) => c.id == country).phoneMask;
    },
  },
  mounted() {
    this.contactForm = this.values;
  },
  updated() {
    this.contactForm = this.values;
  },
  computed: {
    filteredCountries() {
      return [
        {
          id: null,
          name: "Otro",
          phoneCode: null,
          phoneMask: null,
        },
      ].concat(this.countries.filter((c) => c.phoneCode != null));
    },
  },
};
</script>
